import { PenSquare, Search, Music, Loader2 } from 'lucide-react';
import { Input } from '../ui/input';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '../ui/dialog';

export const NewMessageDialog = ({
  open, onOpenChange,
  artistSearch, setArtistSearch,
  filteredArtists, loadingArtists,
  startingChat, onStartConversation,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-surface border-[#262626] max-w-md">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><PenSquare className="w-5 h-5 text-lime" />New Message</DialogTitle>
        <DialogDescription>Select an artist to start a conversation</DialogDescription>
      </DialogHeader>
      <div className="relative mb-2">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#666]" />
        <Input
          value={artistSearch}
          onChange={(e) => setArtistSearch(e.target.value)}
          className="input-dark pl-10"
          placeholder="Search artists..."
          data-testid="search-artist-input"
        />
      </div>
      <div className="max-h-[300px] overflow-y-auto space-y-1">
        {loadingArtists ? (
          <div className="flex justify-center py-8"><Loader2 className="w-5 h-5 animate-spin text-lime" /></div>
        ) : filteredArtists.length === 0 ? (
          <p className="text-center text-sm text-[#666] py-6">No artists found</p>
        ) : (
          filteredArtists.map((artist) => (
            <button
              key={artist.id}
              onClick={() => onStartConversation(artist.id)}
              disabled={startingChat === artist.id}
              className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-[#1a1a1a] transition-colors text-left"
              data-testid={`select-artist-${artist.id}`}
            >
              <div className="w-10 h-10 rounded-full bg-[#1a1a1a] border border-[#333] overflow-hidden flex-shrink-0">
                {artist.image_url ? (
                  <img src={artist.image_url} alt="" className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center"><Music className="w-5 h-5 text-[#404040]" /></div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-sm truncate">{artist.name}</p>
                {artist.genres?.length > 0 && (
                  <p className="text-xs text-[#666] truncate">{artist.genres.join(', ')}</p>
                )}
              </div>
              {startingChat === artist.id && <Loader2 className="w-4 h-4 animate-spin text-lime flex-shrink-0" />}
            </button>
          ))
        )}
      </div>
    </DialogContent>
  </Dialog>
);
